import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { UlItem } from '@com-delta-idp/mnx-ui-kit';
import {
  AddAddressContent,
  AddressLine,
  AddressOverlayMessage
} from './models/add-address.interface';
@Component({
  selector: 'idp-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddAddressComponent implements OnInit, OnDestroy {
  addAddressForm!: UntypedFormGroup;

  @Input() content: AddAddressContent | null = {} as AddAddressContent;
  @Input() machCore = false;

  @Output() focusInvalidField: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() formSubmitEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() fieldFocusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeOverlayMessage: EventEmitter<AddressOverlayMessage> =
    new EventEmitter<AddressOverlayMessage>();

  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() countryChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() resetForm: EventEmitter<void> = new EventEmitter<void>();
  @Output() triggerClose = new EventEmitter();

  ngOnInit(): void {
    this.addAddressForm = this.content.formGroup;
  }

  addressLineOneFormControl(): UntypedFormControl {
    return this.addAddressForm?.get('addressLine1') as UntypedFormControl;
  }

  get showErrorMessageAddressLineOne(): boolean {
    const control = this.addressLineOneFormControl();
    return (
      control?.invalid && this.content.formAttributes.addressLine1ControlTouched
    );
  }

  addressLineTwoFormControl(): UntypedFormControl {
    return this.addAddressForm?.get('addressLine2') as UntypedFormControl;
  }

  get showErrorMessageAddressLineTwo(): boolean {
    const control = this.addressLineTwoFormControl();
    return (
      control?.invalid && this.content.formAttributes.addressLine2ControlTouched
    );
  }

  cityFormControl(): UntypedFormControl {
    return this.addAddressForm?.get('city') as UntypedFormControl;
  }

  get showErrorMessageCity(): boolean {
    const control = this.cityFormControl();
    return control.invalid && this.content.formAttributes.cityControlTouched;
  }

  districtFormControl(): UntypedFormControl {
    return this.addAddressForm?.get('district') as UntypedFormControl;
  }

  get showErrorMessageDistrict(): boolean {
    const control = this.districtFormControl();
    return (
      control.invalid && this.content.formAttributes.districtControlTouched
    );
  }

  countryFormControl(): UntypedFormControl {
    return this.addAddressForm?.get('country') as UntypedFormControl;
  }

  get showErrorMessageCountry(): boolean {
    const control = this.countryFormControl();
    return control.invalid && this.content.formAttributes.countryControlTouched;
  }

  stateFormControl(): UntypedFormControl {
    return this.addAddressForm?.get('state') as UntypedFormControl;
  }

  get showErrorMessageState(): boolean {
    const control = this.stateFormControl();
    return control.invalid && this.content.formAttributes.stateControlTouched;
  }

  postalCodeFormControl(): UntypedFormControl {
    return this.addAddressForm?.get('postalCode') as UntypedFormControl;
  }

  get showErrorMessagePostalCode(): boolean {
    const control = this.postalCodeFormControl();
    return (
      control.invalid && this.content.formAttributes.postalCodeControlTouched
    );
  }

  getAddressLine(addressLine: string): AddressLine {
    return this.content.pageContent.addressFields[addressLine];
  }

  onFocusFirstInvalidField(): void {
    this.focusInvalidField.emit();
  }

  onChange(): void {
    this.inputChange.emit();
  }

  onSubmit(): void {
    this.formSubmitEvent.emit();
  }

  onClosePopup(): void {
    this.closeOverlayMessage.emit({ isSuccess: false, isError: false });
  }

  onFocussedOut(fieldName: string): void {
    this.fieldFocusOut.emit(fieldName);
  }

  onCountryChange(selectedValue: UlItem) {
    this.countryChange.emit(selectedValue?.value);
  }

  ngOnDestroy(): void {
    this.resetForm.emit();
  }
}
